import { render, staticRenderFns } from "./SelectLeague.vue?vue&type=template&id=28a86224&scoped=true&"
import script from "./SelectLeague.vue?vue&type=script&lang=js&"
export * from "./SelectLeague.vue?vue&type=script&lang=js&"
import style0 from "./SelectLeague.vue?vue&type=style&index=0&id=28a86224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a86224",
  null
  
)

export default component.exports